import { lazy } from "react";

const NganhHangHoa = lazy(() => import("./NganhHangHoa"));

const NhomHangHoa = lazy(() => import("./NhomHangHoa"));

const MatHang = lazy(() => import("./MatHang"));
const XemChiTietHangHoa = lazy(() => import("./XemChiTietHangHoa"));

const DeXuatMatHang = lazy(() => import("./DeXuatMatHang"));
const XemDeXuatHangHoa = lazy(() => import("./XemDeXuatHangHoa"));

const CreateDanhMucHangHoa = lazy(() => import("./CreateDanhMucHangHoa"));

const UpdateDanhMucHangHoa = lazy(() => import("./UpdateDanhMucHangHoa"));

const DeXuatGiaMatHang = lazy(() => import("./DeXuatGiaMatHang"));

const DieuChinhGiaHangHoa = lazy(() => import("./DieuChinhGiaHangHoa"));
const DieuChinhThongTinHangHoa = lazy(
  () => import("./DieuChinhThongTinHangHoa"),
);
const DieuChinhDinhMucHangHoa = lazy(() => import("./DieuChinhDinhMucHangHoa"));
const BaoCaoDieuChinhGia = lazy(() => import("./BaoCaoDieuChinhGia"));
const BaoCaoDieuChinhDinhMuc = lazy(() => import("./BaoCaoDieuChinhDinhMuc"));

export {
  BaoCaoDieuChinhDinhMuc,
  BaoCaoDieuChinhGia,
  CreateDanhMucHangHoa,
  DeXuatGiaMatHang,
  DeXuatMatHang,
  DieuChinhDinhMucHangHoa,
  DieuChinhGiaHangHoa,
  DieuChinhThongTinHangHoa,
  MatHang,
  NganhHangHoa,
  NhomHangHoa,
  UpdateDanhMucHangHoa,
  XemChiTietHangHoa,
  XemDeXuatHangHoa,
};
